import React from 'react';
import styled from 'styled-components';

export const CloseButton = ({ onClick, disabled, ...rest }) => {
  const handleClick = (event) => {
    if (disabled) {
      return;
    }
    if (onClick) {
      onClick(event);
    }
  };

  return (
    <Button {...rest} onClick={handleClick} disabled={disabled}>
      <span className="sr-only">Close</span>
    </Button>
  );
};

const Button = styled.button`
  width: 2rem;
  height: 2rem;
  padding: 0;
  position: absolute;
  top: ${({ top = '1.5rem' }) => top};
  right: ${({ right = '2rem' }) => right};
  cursor: pointer;
  border: none;
  background-color: transparent;
  &:hover,
  &:active,
  &:focus {
    outline: none;
  }
  ::before,
  ::after {
    content: '';
    width: 3px;
    height: 100%;
    background-color: ${({ theme }) => theme.colors.primary};
    display: block;
    transform: rotate(45deg) translateX(0px);
    position: absolute;
    left: 50%;
    top: 0;
  }
  ::after {
    transform: rotate(-45deg) translateX(0px);
  }
  > .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }
`;
